<div class="loading-shade" *ngIf="isLoading">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
</div>

<div class="footer" *ngIf="relatedHandover.isHoInEmitterSide">
  <div class="footer-no-data" *ngIf="!this.isHOLOC">Esta seccion ya no es editable por usted.</div>
  <div class="footer-no-data-origin" *ngIf="!relatedHandover.isRelatedHoTaken" >
    El {{relatedHandover.relatedHandoverTypeName}} creado el {{relatedHandover.creationDate | date: 'dd/MM/yyyy'}}, está siendo editado por el equipo {{this.isHOLOC ? 'Operativo': 'Company Man'}}.
  </div>
  <div class="footer-no-data-origin" *ngIf="relatedHandover.isRelatedHoTaken">
    El {{relatedHandover.relatedHandoverTypeName}} creado el {{relatedHandover.creationDate | date: 'dd/MM/yyyy'}}, está siendo editado por {{relatedHandover.usernameEditor}}.</div>
</div>

<p class="title-section">Checks entrega de locacion</p>

<div
  class="deliveryLocation-panel main-ho-notifications"
  *ngIf="displayhandoverType"
>
  <div class="fields">
    <mat-form-field class="selector" appearance="fill">
      <mat-label>Tipo de Pozo</mat-label>
      <mat-select
        [(ngModel)]="chosenDeliveryWellSelect"
        (selectionChange)="onChangeDeliveyWellType($event.value)"
        [disabled]="readOnlyContent"
        (ngModelChange)="saveDiscoverySelect(chosenDeliveryWellSelect)"
      >
        <mat-option
          *ngFor="let deliveryWellSelect of deliveryWellSelect"
          [value]="deliveryWellSelect"
        >
          {{ deliveryWellSelect.deliveryLocationWellLabel }}
        </mat-option>
      </mat-select>
      <mat-hint class="alert" *ngIf="disablewellselect"
        >Este campo es obligatorio.</mat-hint
      >
    </mat-form-field>
  </div>
</div>

<div class="deliveryLocation-panel">
  <div
    class="deliveryLocation"
    *ngFor="let checkDeliveryLocation of checkDeliveryLocations"
  >
    <div class="control">
      <div class="toggle">
        <mat-slide-toggle
          [checked]="checkDeliveryLocation.activeSelected"
          (change)="onCheckDeliveryLocationChange(checkDeliveryLocation)"
          [(ngModel)]="checkDeliveryLocation.activeSelected"
          [disabled]="readOnlyContent"
        >
          {{
            checkDeliveryLocation.activeSelected
              ? checkDeliveryLocation.locationStatusLabelActive
              : checkDeliveryLocation.locationStatusLabelInactive
          }}
        </mat-slide-toggle>
      </div>
      <div class="fields">
        <mat-form-field *ngIf="checkDeliveryLocation.activeSelected">
          <mat-label>N°OT/N°Reclamo</mat-label>
          <div matTooltip="{{ checkDeliveryLocation.complaintNumber }}">
            <input
              matInput
              type="number"
              (change)="onCheckDeliveryLocationChange(checkDeliveryLocation)"
              [(ngModel)]="checkDeliveryLocation.complaintNumber"
              [disabled]="readOnlyContent"
            />
          </div>
          <mat-hint>
            
          </mat-hint>
        </mat-form-field>
        <mat-form-field *ngIf="checkDeliveryLocation.activeSelected">
          <mat-label>Responsable</mat-label>
          <div matTooltip="{{ checkDeliveryLocation.assignedUser }}">
            <input
              matInput
              type="text"
              (change)="onCheckDeliveryLocationChange(checkDeliveryLocation)"
              [(ngModel)]="checkDeliveryLocation.assignedUser"
              [disabled]="readOnlyContent"
            />
          </div>
          <mat-hint
            class="alert"
            *ngIf="!readOnlyContent && !checkDeliveryLocation.assignedUser"
            >Este campo es obligatorio.</mat-hint
          >
        </mat-form-field>
        <mat-form-field *ngIf="checkDeliveryLocation.activeSelected">
          <mat-label>Fecha acordada</mat-label>
          <input
            matInput
            [matDatepicker]="agreedDate"
            (dateChange)="onCheckDeliveryLocationChange(checkDeliveryLocation)"
            [(ngModel)]="checkDeliveryLocation.agreedDate"
            [disabled]="readOnlyContent"
            name="agreedDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [disabled]="readOnlyContent"
            [for]="agreedDate"
          ></mat-datepicker-toggle>
          <mat-datepicker #agreedDate></mat-datepicker>
          <mat-hint
            class="alert"
            *ngIf="!readOnlyContent && !checkDeliveryLocation.agreedDate"
            >Este campo es obligatorio.</mat-hint
          >
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="deliveryLocation-actions" *ngIf="!readOnlyContent">
    <button mat-button class="save" title="Guardar" (click)="save()">
      <mat-icon class="material-icons-outlined">save</mat-icon>Guardar
    </button>
  </div>

</div>

<div class="deliveryLocation-panel">
  <button
    mat-icon-button
    class="add-button"
    [ngClass]="{ remove: true }"
    [disabled]="readOnlyContent || disableAddTask"
    (click)="addTask()"
  >
    <mat-icon class="material-icons-outlined">add_circle</mat-icon>
    <mat-label>Agregar otras tareas/acciones </mat-label>
  </button>

  <div
    class="deliveryLocation task {{
      taskDeliveryLocation.handoverLocationStatusId ? '' : 'newtask'
    }}"
    *ngFor="let taskDeliveryLocation of taskDeliveryLocations"
  >
    <div class="fields">
      <mat-form-field>
        <mat-label>Describi el problema</mat-label>
        <div matTooltip="{{ taskDeliveryLocation.taskLabel }}">
          <input
            matInput
            type="text"
            (change)="onTaskDeliveryLocationChange(taskDeliveryLocation)"
            [(ngModel)]="taskDeliveryLocation.taskLabel"
            [disabled]="readOnlyContent"
          />
        </div>
        <mat-hint
          class="alert"
          *ngIf="!readOnlyContent"
          >Este campo es obligatorio.</mat-hint
        >
      </mat-form-field>
      <mat-form-field>
        <mat-label>N°OT/N°Reclamo</mat-label>
        <div matTooltip="{{ taskDeliveryLocation.complaintNumber }}">
          <input
            matInput
            type="number"
            (change)="onTaskDeliveryLocationChange(taskDeliveryLocation)"
            [(ngModel)]="taskDeliveryLocation.complaintNumber"
            [disabled]="readOnlyContent"
          />
        </div>
        <mat-hint>
       
        </mat-hint>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Responsable</mat-label>
        <div matTooltip="{{ taskDeliveryLocation.assignedUser }}">
          <input
            matInput
            type="text"
            (change)="onTaskDeliveryLocationChange(taskDeliveryLocation)"
            [(ngModel)]="taskDeliveryLocation.assignedUser"
            [disabled]="readOnlyContent"
          />
        </div>
        <mat-hint
          class="alert"
          *ngIf="!readOnlyContent"
          >Este campo es obligatorio.</mat-hint
        >
      </mat-form-field>
      <mat-form-field>
        <mat-label>Fecha acordada</mat-label>
        <input
          matInput
          [matDatepicker]="agreedDate"
          (dateChange)="onTaskDeliveryLocationChange(taskDeliveryLocation)"
          [(ngModel)]="taskDeliveryLocation.agreedDate"
          [disabled]="readOnlyContent"
          name="agreedDate"
        />
        <mat-datepicker-toggle
          matSuffix
          [disabled]="readOnlyContent"
          [for]="agreedDate"
        ></mat-datepicker-toggle>
        <mat-datepicker #agreedDate></mat-datepicker>
        <mat-hint
          class="alert"
          *ngIf="!readOnlyContent"
          >Este campo es obligatorio.</mat-hint
        >
      </mat-form-field>
    </div>
    <button
      mat-button
      [ngClass]="{ ready: true }"
      [disabled]="readOnlyContent"
      (click)="saveTask(taskDeliveryLocation)"
    >
      LISTO
    </button>
    <button
      mat-icon-button
      [ngClass]="{ remove: true }"
      [disabled]="readOnlyContent"
      (click)="deleteTask(taskDeliveryLocation)"
    >
      <mat-icon class="material-icons-outlined">delete</mat-icon>
    </button>
  </div>
</div>

<!-- File Attachment -->
<div class="deliveryLocation-panel" *ngIf="displayhandoverType">
  <div class="top">
    <h2>Documentacion tecnica</h2>
    <div clas="count">
      <div *ngIf="fileatttachmentresult == null">
        0 {{ "/" + fileLimit + " Documentos" }}
      </div>
      <div *ngIf="fileatttachmentresult != null">
        {{ fileatttachmentresult?.length + "/" + fileLimit + " Documentos" }}
      </div>
    </div>
  </div>
  <div class="handover-images" *ngFor="let f of fileatttachmentresult">
    <div class="top">
      <div class="notification-panel">
        <div class="notification">
          <ng-container>
            <div class="control">
              <div>
                <!-- Text are descripcion del Documento adjunto -->
                <mat-form-field class="mat-form-field-file">
                  <mat-label>Nombre del Documento</mat-label>
                  <input
                    matInput
                    type="text"
                    (blur)="updateDescription(f.file_description, f.file_id)"
                    [(ngModel)]="f.file_description"
                    maxlength="50"
                    [disabled]="readOnlyContent"
                  />
                </mat-form-field>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <a
        class="attachment-link"
        href="{{dhoApiUrl}}/{{ f?.file_path }}"
        target="_blank"
      >
        {{ f?.file_path }}
      </a>
      <!-- Boton borrar-->
      <button
        mat-button
        class="delete-button"
        (click)="deleteAttachment(f.file_id)"
        [disabled]="readOnlyContent"
      >
        <mat-icon class="material-icons-outlined">delete</mat-icon>
      </button>

      <ng-container *ngIf="!f.file_path">
        <input
          type="file"
          class="file-input"
          accept=".xls, .xlsx, .pdf"
          (change)="onFileSelected($event)"
          #fileUpload
          style="display: none"
        />

        <div class="attach" title="Documento" *ngIf="!f.file_path">
          <button
            mat-button
            class="attachment-button"
            (click)="fileUpload.click()"
            title="{{ f.filePath }}"
            [disabled]="buttonFile"
          >
            <mat-icon class="material-icons-outlined">file_upload</mat-icon
            >{{ f.filePath }}</button
          ><br />
          <span *ngIf="!f.file_path"
            >Archivos PDF, JPG, XLSX están permitidos</span
          >
        </div>
      </ng-container>
    </div>
  </div>

  <div class="handover-images">
    <div class="top" *ngIf="fileatttachmentresult?.length < fileLimit">
      <div class="notification-panel">
        <div class="notification">
          <ng-container>
            <div class="control">
              <div>
                <mat-form-field class="mat-form-field-file">
                  <mat-label>Nombre del Documento</mat-label>
                  <input
                    #descripcionfile
                    matInput
                    [(ngModel)]="descripcion"
                    maxlength="50"
                    [disabled]="readOnlyContent"
                  />
                  <mat-hint align="end">
                    {{ descripcionfile.value.length }} / 50</mat-hint
                  >
                </mat-form-field>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <ng-container>
        <input
          type="file"
          class="file-input"
          accept=".xls, .xlsx, .pdf"
          (change)="onFileSelected($event)"
          #fileUpload
          style="display: none"
        />

        <div class="attach" title="Documento">
          <button
            mat-button
            (click)="fileUpload.click()"
            [disabled]="readOnlyContent"
          >
            <mat-icon class="material-icons-outlined">file_upload</mat-icon
            >Adjuntar documento</button
          ><br />
          <span>Archivos PDF, JPG, XLSX están permitidos</span>
        </div>
      </ng-container>
    </div>
  </div>
</div>
